import React from "react";
import {apiEndpoint} from "helpers/url_helper";


import { useEffect, useState } from 'react';
import ReactApexChart from "react-apexcharts"
import { Card } from "reactstrap";
import {CardBody} from "reactstrap";
import {Row,Col} from "reactstrap";
const areachart= props =>  {
  const [violations, setviolations] = useState([]);
  const [vehiclecount, setvehiclecount] = useState([]);
  const [locations, setlocations] = useState([]);
  const [violationCnt, setviolationCnt] = useState([]);
  const [vehicleCountNo, setvehicleCountNo] = useState([]);

  
  useEffect(() => {
   
    var intCampusID=props.CampusID;
    //console.log(intCampusID)
    const getData = async () => {
      // UserValidated
    const url = apiEndpoint+'/GetWeeklyData';
    try {
      // axios.post(url).then(function(response) {
      //   areachart.updateSeries([{
      //     name: 'Violations',
      //     data: response.Violations
      //   },{
      //     name: 'Vehicle Count',
      //     data: response.VehicleCount
      //   }])
      // })

      // const response = await fetch(url, {
      //   method: 'POST', 
      //   mode: 'no-cors'});
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "intCampusID": intCampusID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      });
        //console.log(response);
       if(response.body!=null){
      const data = await response.json();
      //console.log(data);
      
      // var arr=JSON.parse(data.Violations);
      // console.log(arr);
      // arr.map(item => {
      //   violations.push(item.ViolationCount);
      //   locations.push(item.LocationName)
      // });
          
      // setviolations(violations);
      // setlocations(locations);
      if(data.VehicleCount!=null)
       setviolations(JSON.parse(data.VehicleCount)?.map((item) => item.ViolationCount));
      if(data.VehicleCount!=null){
       setlocations(JSON.parse(data.VehicleCount)?.map((item) => item.LocationName));
      }
      if(data.VehicleCount!=null)
       setvehiclecount(JSON.parse(data.VehicleCount)?.map((item) => item.VehicleCount));
    
    
      setviolationCnt(data.violationsCnt)
      setvehicleCountNo(data.vehicleCnt)
      // areachart.updateSeries([{
      //   name: 'Violations',
      //   data: data.Violations
      // }])
      // setviolations(data.Violations.y);
      // setlocations(data.Violations.x);
      // setvehiclecount(data.VehicleCount.y);
       }
    } catch (error) {
        console.log(error);
    }
  };
    getData();
    // setlocations([]);
    // setvehiclecount([]);
    // setviolations([]);

  }, [props.CampusID]);


  const options = {
    // colors: ["#ccc", "#3c4ccf", "#02a499"],
    colors: [ "#3c4ccf", "#02a499"],
    chart: {
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: "smooth",
      width: 0.1,
    },
    grid: {
      borderColor: "#f8f8fa",
      row: {
        colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
   
    legend: {
      show: true,
    },
    xaxis: {
      categories: locations
    }
  }
 
  return (
    <React.Fragment>  
      <Card>

<CardBody>

    <h4 className="card-title mb-4">Violations in last week</h4>
    <Row className="text-center mt-4">
        <Col sm="6">
            <h5 className="mb-0 font-size-20">{vehicleCountNo}</h5>
            <p className="text-muted">Vehicle Count</p>
        </Col>
        <Col sm="6">
            <h5 className="mb-0 font-size-20">{violationCnt}</h5>
            <p className="text-muted">Violation Count</p>
        </Col>      
    </Row>

    <div dir="ltr">
    <ReactApexChart
      options={options}
      series={[{
        name: 'Violations',
        data: violations
      },
      {
        name: 'Vehicle Count',
        data: vehiclecount
      }]} 
      type="area"
      height="300"
    />
    </div>
    </CardBody>
</Card>
    </React.Fragment>
  )
  }

 
export default areachart;
